import React, {forwardRef} from "react";
import {Chip, ChipProps} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {PortTheme} from "~/ui/theme";
import omit from "lodash/omit";


export type ChipInputProps = ChipProps & {
    selected?: boolean
    rounded?: boolean
}


const useStyles = makeStyles<PortTheme, ChipInputProps>(theme => {
    return {
        root: {
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: props => props.selected ? "#3F79B5" : "#6E798C1F",
            borderRadius: props => props.rounded ? "32px" : "8px",
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.paper,
            "&:hover": {
                backgroundColor: theme.palette.background.paper,
            },
        },
        label: {
            display: "inline-flex",
            alignItems: "center",
            padding: "2px 10px",
            "& .MuiSvgIcon-root": {
                marginLeft: "8px"
            }
        }
    }
});


export const ChipInput = forwardRef<any, ChipInputProps>((props, ref) => {
    const classes = useStyles(props);

    return (
        <Chip {...omit(props, "rounded", "selected")} clickable={true} classes={classes} ref={ref}/>
    )
})